import { Box, Typography, styled } from "@mui/material";

const BlackBorderBox = styled(Box)(() => ({
  border: "2px solid black",
  borderRadius: "20px",
  padding: "10px",
  height: "400px",
  overflowX: "auto", // Tambahkan overflow-x untuk pengguliran horizontal
  width: "100%",
}));

const StyledImage = styled("img")(() => ({
  whiteSpace: "nowrap",
}));

export function Profilepage() {
  return (
    <div>
      <div
        style={{
          display: "flex",
          flexFlow: "column",
          justifyContent: "center",
          paddingTop: "8vw",
          width: "80%",
          marginLeft: "10vw",
          marginTop: "3vw",
        }}
      >
        <Typography style={{ fontSize: "20px", fontWeight: "bold" }}>
          STRUKTUR ORGANISASI
        </Typography>
        <BlackBorderBox
          style={{
            height: "600px",
            display: "flex",
            justifyContent: "center",
            whiteSpace: "nowrap", // Tambahkan white-space ke dalam BlackBorderBox
          }}
        >
          <StyledImage
            src="/assets/images/struktur-organisasi.webp"
            alt="Your Image"
            style={{
              marginLeft: "-50px",
              maxWidth: "900px",
            }}
          />
        </BlackBorderBox>
      </div>

      <div
        style={{
          display: "flex",
          flexFlow: "column",
          justifyContent: "center",
          marginTop: "8vw",
          width: "80%",
          marginLeft: "10vw",
        }}
      >
        <Typography style={{ fontSize: "20px", fontWeight: "bold" }}>
          TUGAS DAN FUNGSI
        </Typography>
        <BlackBorderBox
          style={{
            height: "300px",
            padding: "30px",
            overflow: "hidden", // Menggunakan overflow tersembunyi
            textOverflow: "ellipsis", // Menggunakan elipsis jika teks melebihi kotak
            whiteSpace: "wrap",
          }}
        >
          <Typography style={{ fontSize: "16px" }}>
            <b>Tugas</b> : Pelaksana kebijakan dan teknis operasional
            pengelolaan dan pengembangan sistem air limbah dan pemrosesan lumpur
            tinja
          </Typography>

          <Typography style={{ fontSize: "16px" }}>
            <b>Fungsi</b>
            <ol>
              <li>
                Pelaksanaan kebijakan, penataan, pengembangan, dan pemeliharaan
                dalam rangka pemenuhan kebutuhan pengelolaan air limbah domestik
                khususnya lumpur tinja;
              </li>
              <li>
                Pelaksanaan pelayanan pengelolaan air limbah domestik lumpur
                tinja;
              </li>
              <li>
                Pelaksanaan kegiatan operasi dan pemeliharaan sarana dan
                prasarana pengelolaan air limbah;
              </li>
              <li>
                Pelaksanaan pemungutan retribusi air limbah domestik lumpur
                tinja sesuai regulasi;
              </li>
              <li>Pelaksanaan ketatausahaan dan urusan rumah tangga;</li>
              <li>Pelaksanaan analisis dan pengembangan kinerja;</li>
              <li>
                Pelaksanaan tugas-tugas lain yang diberikan oleh Kepala Dinas
                Perumahan Rakyat dan Kawasan Permukiman sesuai dengan tugas dan
                fungsinya.
              </li>
            </ol>
          </Typography>
        </BlackBorderBox>
      </div>

      <div
        style={{
          display: "flex",
          flexFlow: "column",
          justifyContent: "center",
          marginTop: "8vw",
          marginBottom: "8vw",
          width: "80%",
          marginLeft: "10vw",
        }}
      >
        <Typography style={{ fontSize: "20px", fontWeight: "bold" }}>
          ALAMAT KANTOR
        </Typography>
        <BlackBorderBox style={{ height: "850px", padding: "30px" }}>
          <Typography style={{ lineHeight: "0.8" }}>
            <p>
              <b>
                Dinas Perumahan Rakyat dan Kawasan Permukiman Kabupaten Ngawi
              </b>
            </p>
            <p>
              Jl. Raya Ngawi – Cepu KM 3 Ngawi, Kode Pos 63218 Telepon (0351)
              749005, Faksimile (0351) 748958{" "}
            </p>
            <p>
              Laman : https://dprkp.ngawikab.go.id, Pos-el :
              perkim@ngawikab.go.id
            </p>
          </Typography>
          {/* Sisipkan peta Google Maps dengan iframe */}
          <iframe
            title="iFrame"
            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d2679.167956466362!2d111.46150044603272!3d-7.391370310848353!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e79e72403e1e16f%3A0xfbc66431a6400014!2sDinas%20Perumahan%20Rakyat%20dan%20Kawasan%20Permukiman%20Kabupaten%20Ngawi!5e0!3m2!1sid!2sid!4v1694860619197!5m2!1sid!2sid"
            width="100%"
            height="300"
            style={{ border: "0" }}
            allowFullScreen=""
            loading="lazy"
          ></iframe>

          <Typography style={{ lineHeight: "0.8", marginTop: "30px" }}>
            <p>
              <b>IPLT Kabupaten Ngawi</b>
            </p>
            <p>Desa Karang Tengah Prandon, Kecamatan Ngawi</p>
          </Typography>

          {/* Sisipkan peta Google Maps dengan iframe */}
          <iframe
            title="iFrame"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3956.68685373237!2d111.47475947485162!3d-7.388944272739608!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e79ddeca28d3069%3A0x730e7d6ba1f2249c!2sIPLT%20KAB.%20NGAWI!5e0!3m2!1sid!2sid!4v1694861041301!5m2!1sid!2sid"
            width="100%"
            height="300"
            style={{ border: "0" }}
            allowFullScreen=""
            loading="lazy"
          ></iframe>
        </BlackBorderBox>
      </div>
    </div>
  );
}
